import { useController, useFormContext } from "react-hook-form";
import { CalendarPickerSingleRhfProps } from "./CalendarPicker";
import CalendarPickerComponent from "./CalendarPickerComponent";

export default function CalendarPickerSingleRhf(
  props: CalendarPickerSingleRhfProps
) {
  const { name, ...rest } = props;

  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ control, name });

  function handleChange(value: Date) {
    onChange(value);
    props.onChange?.(); // Call the onChange prop if provided
  }

  return (
    <CalendarPickerComponent {...rest} onChange={handleChange} value={value} />
  );
}
